<template>
  <nav id="main-nav" class="container-fluid bg-white border-bottom">
    <div class="d-flex justify-content-between align-items-center py-2 py-md-3">
      <div class="d-flex">
        <button @click="toggleMenu" class="btn btn-icon p-2 ml-n2 mr-1 d-md-none" title="Menu">
          <IconifyIcon :icon="isOpen ? icons.bxMenu : icons.bxMenu" height="24" />
        </button>
        <MobiusLogo to="/home" />
      </div>

      <div class="d-flex align-items-center">
        <router-link to="/admin-panel" v-if="role !== 'ROLE_STUDENT'" class="d-flex ml-2 mr-2">
          <IconifyIcon :icon="icons.bxCog" height="24"/> Administración
        </router-link>
        <router-link to="/dashboard">
          <img class="ml-2" src="../assets/images/avatars/avatar-00.png" alt="" />
        </router-link>
        <button
          @click="logout"
          class="btn btn-icon p-2 ml-2"
          title="Cerrar sesión">
          <IconifyIcon :icon="icons.bxLogIn" height="24" />
        </button>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState } from "vuex";
import IconifyIcon from "@iconify/vue";
import bxLogIn from "@iconify/icons-bx/bx-log-in";
import bxMenu from "@iconify/icons-bx/bx-menu";
import bxCog from "@iconify/icons-bx/bx-cog";
import MobiusLogo from "@/components/MobiusLogo.vue";

export default {
  name: "TopNavbar",
  components: {
    IconifyIcon,
    MobiusLogo,
  },
  props: {
    login: Boolean,
  },
  data: () => {
    return {
      profileImg: null,
      icons: {
        bxLogIn,
        bxMenu,
        bxCog
      },
      isOpen: false,
      role: ""
    };
  },
  methods: {
    logout() {
      this.goToLogin();
    },
    goToLogin() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login").catch(() => {});
    },
    toggleMenu() {
      this.$emit("toogle-menu");
      this.isOpen = !this.isOpen;
    },
  },
  mounted: function () {
    this.role = this.$store.state.auth.data.role;
    this.profileImg = this.$store.state.auth.data.imageUrl;
    if(this.$store.state.auth.data.provider === 'local' || ! this.profileImg) {
      console.log("Using image");
    }
    this.profileImg = "../assets/images/avatars/avatar-00.png";
  },
  computed: {
    ...mapState(["auth"]),
  },
};
</script>

<style scoped>
#main-nav {
  position: sticky;
  z-index: 3;
  top: 0;
  height: 84px;
  position: sticky;
  transition: background-color 500ms ease;
}

.main-nav__logo {
  height: 54px;
}

@media screen and (max-width: 768px) {
  #main-nav {
    height: 58px;
  }

  .main-nav__logo  {
    height: 36px;
  }
}
</style>
